import script from "./LayoutMain.vue?vue&type=script&setup=true&lang=js"
export * from "./LayoutMain.vue?vue&type=script&setup=true&lang=js"

import "./LayoutMain.vue?vue&type=style&index=0&id=7983ec63&lang=css"

const __exports__ = script;

export default __exports__